import React from "react";
import ToastCompact, { ToastCompactProps } from "./ToastCompact";

interface ClickableToastProps extends ToastCompactProps {
  onClick: () => void;
}

export const ClickableToast: React.FC<ClickableToastProps> = ({
  onClick,
  ...toastContentProps
}) => {
  return (
    <div onClick={onClick} className="cursor-pointer">
      <ToastCompact {...toastContentProps} />
    </div>
  );
};
